export const actionsList = [
  // {
  //   id: 1,
  //   name: "export",
  //   icon: "download",
  //   colorType: ""
  // },
  {
    id: 2,
    name: "duplicate",
    icon: "copy",
    colorType: ""
  },
  {
    id: 3,
    name: "delete",
    icon: "trash",
    colorType: "error"
  }
];
